import { message } from 'antd';
import { Toast, Modal } from 'antd-mobile';
import Tools from 'utils/Tools';
import GlobalParameters from './config';
import store from 'redux/store';
import * as actionTypes from 'redux/actionType';
import axios from 'axios';
axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.headers.common['platform'] = 'guest_common';
axios.defaults.withCredentials = true; // 需要跨域携带认证

const isWx = window.navigator.userAgent.toLowerCase().includes('micromessenger'); // 限制微信打开

const REDIRECTLIMIT = 5; // 重定向次数限制

const $alert = Modal.alert;

// 字符串转16进制
const stringToHex = (str) => {
  const array = [];
  for (let i = 0; i < str.length; i++) {
    array[i] = str.charCodeAt(i).toString(16);
  }
  return array.join('');
};

const getLoginUrl = (url) => {
  const [origin, params] = url.split('?');
  if (!params) return origin;
  const { href } = window.location;
  const routerObject = Tools.getRequest(`?${params}`);
  routerObject.redirect_uri = `${routerObject.redirect_uri}%2F${stringToHex(href)}`;
  let str = '?';
  for (const key in routerObject) {
    str += `${key}=${routerObject[key]}&`;
  }
  return `${origin}${str}`;
};

class Httprequest {
  constructor() {
    this.timeout = 50000; // 请求的超时时间50秒
    this.queue = {}; // 请求队列,防止重复点击
    this.loadingCount = 0;
    this.loadingInstance = null;
  }

  _closeLoading(isLoading) {
    if (isLoading) {
      this.loadingCount--;
      if (this.loadingCount <= 0) {
        this.loadingInstance.close();
        this.loadingCount = 0;
      }
    }
  }

  setinterceptors(instance, isLoading, isCancel, unique) {
    instance.interceptors.request.use((config) => {
      // if (config.method.toUpperCase() === 'GET') {
      //   config.params = { ...GlobalParameters, ...config.params };
      // } else {
      //   config.data = { ...GlobalParameters, ...config.data };
      // }
      if (config.method.toUpperCase() === 'GET') {
        config.params = { ...GlobalParameters, ...config.params };
      } else {
        if (config.headers['Content-Type'] === 'multipart/form-data') {
          Object.keys(GlobalParameters).forEach((key) => {
            config.data.append(key, GlobalParameters[key]);
          });
        } else {
          config.data = { ...GlobalParameters, ...config.data };
        }
      }
      if (this.queue[unique]) {
        throw 'EXCEPTION:REPEATCLICK';
      } else {
        this.queue[unique] = unique;
      }

      if (isLoading) {
        this.loadingCount++;
        this.loadingInstance = window.$utils.GlobalLoading.service();
      }
      if (isCancel) {
        config.cancelToken = new axios.CancelToken((cancel) => {
          store.dispatch({ type: actionTypes.AXIOS_ENQUEUE, data: cancel });
        });
      }

      return config;
    });

    instance.interceptors.response.use(
      (res) => {
        delete this.queue[unique];
        this._closeLoading(isLoading);
        const { config = {} } = res;
        const { url } = config;
        const { code, message, data } = res.data;
        const html = document.documentElement;
        const redirectCount = localStorage.getItem('redirectCount') || 0;
        console.log('redirectCount', +redirectCount);
        if (code != 200 && code !== '0' && code !== '-2' && code !== '40001') {
          if (code == '-1' && data?.redirectUrl && url.includes('getUserBaseInfo')) {
            // getUserBaseInfo这个接口走一次redirectCount +1 ，到第6次展示弹窗
            localStorage.setItem('redirectCount', +redirectCount + 1);
            if (+redirectCount >= REDIRECTLIMIT) {
              html.style.backgroundColor = '#f0f2f5';
              $alert('提示', '登录信息过期，请重新授权登录', [
                {
                  text: '确认',
                  onPress: () => {
                    window.location.href = getLoginUrl(data.redirectUrl);
                  },
                },
              ]);
              return Promise.reject(res.data);
            } else {
              window.location.href = getLoginUrl(data.redirectUrl);
              return Promise.reject(res.data);
            }
          } else {
            Toast.fail(message || '接口异常');
            return Promise.reject(res.data);
          }
        }
        localStorage.setItem('redirectCount', 0);
        return Promise.resolve(res.data);
      },
      (error) => {
        this._closeLoading(isLoading);
        if (error === 'EXCEPTION:REPEATCLICK') {
          // message.warning('');
        } else if (error.__proto__.constructor.name === 'Cancel') {
          delete this.queue[unique];
          console.log('请求取消');
        } else {
          delete this.queue[unique];
          Toast.fail('服务器异常');
        }

        return Promise.reject(error.message);
      }
    );
  }

  request(options, { isLoading = true, isCancel = true } = {}) {
    let instance = axios.create();
    const searchObject = Tools.getRequest(window.location.href || window.location.search) || {};
    const { appId, appCode = 'xiaoliAI' } = searchObject;
    console.log(searchObject);
    const { headers = {} } = options;
    const newHeaders = {
      ...headers,
      // 安全认证
      clientType: isWx ? 'wx' : 'pc',
      token: searchObject.token || searchObject.PHOTON_TOKEN || '123',
      appCode,
      corpId: appId || window.corpId,
    };
    options.method || (options.method = 'post');
    let config = {
      // baseURL: "/api",
      timeout: this.timeout,
      ...options,
      headers: newHeaders,
    };
    // 确定唯一性(路由+接口地址+请求方式)
    const unique = `${window.location.href}${config.method}${config.url}`.toLocaleUpperCase();
    this.setinterceptors(instance, isLoading, isCancel, unique);
    return instance(config);
  }
}

const http = new Httprequest();

export default http.request.bind(http);
